import { PageHeader } from "@/pages/layoutChrome";
import ModuleClientSelector from "@/components/ModuleClientSelector";
import CheckIdValidator from "@/components/checkid/CheckIdValidator";
import { TRAMITES_CONTEXT_LABEL } from "@/modules/tramites/manifest";

/**
 * Pantalla Trámites — Validador NSS (permanece en módulo Trámites Fiscales).
 */
export default function TramitesValidadorNss() {
  return (
    <div className="space-y-6" data-testid="tramites-validador-nss-page">
      <PageHeader
        title="Validador NSS (IMSS / IDSE)"
        subtitle="Validación local de NSS, RFC, CURP y consistencia antes de trámites IMSS/IDSE."
        breadcrumb={[TRAMITES_CONTEXT_LABEL, "Validador NSS (IMSS / IDSE)"]}
      />

      <div className="px-8 max-w-6xl">
        <ModuleClientSelector variant="panel" className="mb-6" />
        <CheckIdValidator variant="tramites-nss" />
      </div>
    </div>
  );
}
